<template>
  <div class="box">
    <div class="back" v-on:click="back">
      <img src="../assets/GoBack2.png" alt />
    </div>
    <div style="height: 6.3rem">
      <div class="header">
        <img :src="CShttp + IconImg" alt />
      </div>
      <!-- <div class="money">{{CouponInfo.amount}}元</div> -->
      <div
        class="money"
        v-if="CouponInfo.category == '免费券' && !CouponInfo.amount"
      >
        免
      </div>
      <div class="money" v-else>{{ CouponInfo.amount }}元</div>
      <div class="useMust" v-on:click="watchRule(CouponInfo.use_rule)">
        {{ CouponInfo.use_rule }}
      </div>
      <div class="type">{{ CouponInfo.category }}</div>
      <div class="UseTime">
        有效期：{{ CouponInfo.start_time }}至{{ CouponInfo.end_time }}
      </div>
    </div>

    <div class="EWM">
      <!-- <img src alt /> -->
      <!-- :logoSrc="imageUrl" -->
      <vue-qr :text="codesEWM" :size="200"></vue-qr>
    </div>
    <div class="num">核销码：{{ codesEWM }}</div>
    <div v-if="(showBtn&&uid!=useId)" class="showBtn" v-on:click="share_coupon">领取优惠券</div>
  </div>
</template>

<script>
import vueQr from "vue-qr";
export default {
  name: "",
  data() {
    return {
      CShttp: this.$store.state.CShttp,
      useId:this.$store.state.useId,
      CouponInfo: "",
      IconImg: "",
      codes: "",
      imageUrl: "",
      codesEWM: "",
      showBtn:false,
      uid:''
    };
  },
  components: { vueQr },
  created() {},
  mounted() {
    // document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
    //     // 通过下面这个API隐藏右上角按钮
    //     WeixinJSBridge.call('hideOptionMenu');
    //   });

    var openid = localStorage.getItem("ZQopenid");
    var UserInfo = localStorage.getItem("ZQUserInfo")
      ? JSON.parse(localStorage.getItem("ZQUserInfo"))
      : "";
    var location = JSON.parse(localStorage.getItem("ZQlocation"));
    this.$store.commit("location", location);
    this.$store.commit("UserInfo", {
      UserInfo: UserInfo,
    });
    this.$store.commit(
      "UserSelf",
      JSON.parse(localStorage.getItem("ZQUserSelf"))
    );
    this.UserInfo = UserInfo;
    this.openid = UserInfo.openid;


    if (this.$route.query.CouponInfo) {
      this.CouponInfo = this.$route.query.CouponInfo;
      this.IconImg = this.$route.query.IconImg;
      this.codesEWM = this.CouponInfo.pcodes;
      // (this.codes = this.CouponInfo.codes),
      this.imageUrl = this.CShttp + this.IconImg; //拼出来的地址在二维码插件中存在跨域问题
    } else if (this.$route.query.pcodes) {
      this.showBtn=true
      this.codesEWM = this.$route.query.pcodes;
      this.uid = this.$route.query.id;   //分享人 id
      this.getCoupon();
      console.log(this.uid,this.useId)
    }

    //  this.useCoupon()
    this.GetWx();
  },
  methods: {
     share_coupon() {
       console.log('uid',this.uid,)
       console.log('useId',this.$store.state.useId)
       console.log('code',this.codesEWM)
      this.$http
        .get("/api/Coupon/share_coupon", {
          params: {
            code:this.codesEWM,
            uid:this.$store.state.useId,
            share_uid:this.uid ,

          }
        })
        .then(res => {
          console.log(res)
         if (res.data.code == 1) {
           this.showBtn=false
              this.$store.commit("showLoading", false); //关闭加载图标
              this.$store.commit("showMsg", {
                show: true,
                type: true,
                msg: ""
              }); //显示领取成功
            } else {
              this.$store.commit("showLoading", false); //关闭加载图标
              this.$store.commit("showMsg", {
                show: true,
                type: false,
                msg: res.data.data.action
              }); //显示领取失败
            }
        });
    },
    getCoupon() {
      var that=this
      this.$http
        .get("api/coupon/code_getcoupon?codes=" + this.codesEWM, {})
        .then((res) => {
          console.log("soces", res.data.data.action);
          that.CouponInfo = res.data.data.action;
          that.CouponInfo.category=res.data.data.action.coupontype_name
        });
    },
    GetWx() {
      var that = this;

      var IsPhone = /iphone/.test(navigator.userAgent.toLowerCase()); //判断是不是苹果
      this.$http
        .get("/api/shop/get_SignPackage", {
          params: {
            url: IsPhone
              ? encodeURIComponent(window.entryUrl)
              : encodeURIComponent(location.href),
          },
        })
        .then((res) => {
          console.log(res.data.msg);
          that.$store.commit("wxJSSDK", res.data.msg);
          wx.config({
            debug: false, // true:调试时候弹窗
            appId: res.data.msg.appId, // 微信appid
            timestamp: res.data.msg.timestamp, // 时间戳
            nonceStr: res.data.msg.nonceStr, // 随机字符串
            signature: res.data.msg.signature, // 签名
            jsApiList: [
              // 所有要调用的 API 都要加到这个列表中
              "onMenuShareAppMessage", //获取地理位置
            ],
          });
        });
      wx.ready(function () {
        wx.onMenuShareAppMessage({
          title: "分享商家", // 分享标题
          desc: "核销优惠券", // 分享描述
          link:
            window.location.origin +
            "/redirect.html?shareRedirect=" +
            encodeURIComponent(
              "https://zqconsumer.zeego2.cc?type=giveTo&pcodes=" +
                that.codesEWM +'&id='+(that.showBtn?that.uid:that.$store.state.useId)+
                "#/"
            ), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: that.imageUrl, // 分享图标
          success: function () {
            console.log("分享成功");
            console.log('uid',that.showBtn?that.uid:that.$store.state.useId )
            that.$http
            .get("api/coupon/share_save_coupon", {
              params:{
                code :that.codesEWM,
                uid: that.showBtn?that.uid:that.$store.state.useId 
              }
            })
            .then((res) => {
             console.log("分享请求",res)
            });
            // 设置成功
          },
        });
      });
      wx.error(function () {
        console.log("失败");
      });
    },
    // 查看规则
    watchRule(rule) {
      alert("券规则：" + rule);
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang='scss' scoped>
.showBtn{
  // position: fixed;
  bottom: 0;
  left: 0;
  height: 0.8rem ;
  line-height: 0.8rem;
  text-align: center;
  background: red;
  color: white;
  width: 70%;
  border-radius: 0.2rem;
  margin:0 auto;
  margin-top: 1rem;  
}
.box {
  width: 100%;
  height: 100vh;
  background-image: url(../assets/toUseBack.jpg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.box > div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}
.back {
  position: absolute;
  top: 0.5rem;
  left: 0.2rem;
  width: 0.7rem;
  height: 0.7rem;
  z-index: 1000;
}
.back img {
  width: 100%;
  height: 100%;
  display: inline-block;
}
.header {
  width: 1.28rem;
  height: 1.28rem;
  border-radius: 100%;
  overflow: hidden;
  margin-top: 0.82rem;
}
.header img {
  width: 100%;
  height: 100%;
}
.money {
  font-size: 1.04rem;
  color: white;
  margin-top: 0.28rem;
  line-height: 1.08rem;
}
.useMust {
  font-size: 0.3rem;
  line-height: 0.42rem;
  margin-bottom: 0.14rem;
  color: white;
  max-width: 6rem;
  overflow: hidden;
  /*不换行*/
  white-space: nowrap;
  /*添加...*/
  text-overflow: ellipsis;
}
.type {
  background: white;
  opacity: 0.4;
  font-size: 0.3rem;
  height: 0.5rem;
  line-height: 0.5rem;
  width: 2rem;
  border-radius: 0.1rem;
  text-align: center;
}
.UseTime {
  font-size: 0.24rem;
  color: white;
  line-height: 0.6rem;
}
.EWM {
  width: 3.5rem;
  // height: 3.5rem;
  border: 1px solid black;
  margin-top: 0.8rem;
  margin: 0 auto;
}
.num {
  font-size: 0.32rem;
  color: #333333;
  line-height: 0.44rem;
  margin-top: 0.3rem;
}
</style>
